import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import React, { useContext, useEffect, useState } from "react"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import styles from "./styles"
import { Keyboard, View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import { Button } from "@Components/CustomButton/Button"
import { QuizzContext } from "@Providers/QuizzProvider"
import { EvaluationResultModal } from "./EvaluationResultModal"
import { EvaluationQuizzHeader } from "./EvaluationQuizzHeader"
import { RestultStatistic } from "./RestultStatistic"
import { QuestionItems } from "./QuestionItems"
import { userAtom } from "@Recoil/Atom/userAtom"
import { useRecoilValue } from "recoil"
import { defaultQuizzPayload } from "../EvaluationLogic"
import { useNavigation, useRoute } from "@react-navigation/native"
import { KnowledgeService } from "@Services/Knowledge/Knowledge.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"

export const EvaluationQuizz = () => {
    const route = useRoute()
    const user = useRecoilValue(userAtom)
    const navigation = useNavigation()
    const [fetchingResponse, setFetchingResponse] = useState(false)
    const [isKeyboardVisible, setKeyboardVisible] = useState(false)
    const [sending, setSending] = useState(false)
    const { selectedQuizz } = useContext(QuizzContext)
    const [open, setOpen] = useState(false)
    const [userResponses, setUserResponses] = useState([])

    const userId = user?.id ?? 0
    const quizzId = +selectedQuizz?.id ?? 0
    const [payload, setPayload] = useState({
        ...defaultQuizzPayload,
        userId,
        quizzId
    })
    const [questionLength, setQuestionLength] = useState(0)
    const toggleModal = () => setOpen((prev) => !prev)
    const gotoQuizz = () => navigation.navigate("EvaluationQuizz")

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", () => {
            setKeyboardVisible(true)
        })
        const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
            setKeyboardVisible(false)
        })

        return () => {
            keyboardDidHideListener.remove()
            keyboardDidShowListener.remove()
        }
    }, [])

    const isResult = route?.params?.isResult ?? false
    const handleClickBtn = () => {
        if (isResult) {
            gotoQuizz()
        } else {
            setSending(true)
            KnowledgeService.replyOnQuizz(payload)
                .then(() => {
                    ShowToast({
                        type: "success",
                        message: "Réponse bien envoyée"
                    })
                    setSending(false)
                    setTimeout(() => {
                        toggleModal()
                    }, 1000)
                })
                .catch((error) => {
                    ShowToast({
                        type: "error",
                        message: "Merci de vérifier votre réponse avant de l'envoyer"
                    })
                    setSending(false)
                })
        }
    }

    const handleFetchQuizzResponse = () => {
        setFetchingResponse(true)
        if (userId > 0) {
            KnowledgeService.getUserQuizzResponse({ userId, quizzId })
                .then((response) => {
                    const data = response?.data?.data
                    setUserResponses(data?.reverse())
                    setFetchingResponse(false)
                })
                .catch((error) => {
                    setFetchingResponse(false)
                })
        }
    }

    useEffect(() => {
        handleFetchQuizzResponse()
    }, [quizzId, userId])

    const btnLabel = isResult ? "REFAIRE LE QUIZ" : sending ? "EN COURS..." : "ENVOYER MES RÉPONSES"

    const handleCheckResult = () => toggleModal()

    const disableBtn = isResult
        ? false
        : payload?.checkboxResponses?.length === 0 &&
          payload?.radiosResponses?.length === 0 &&
          payload?.textResponses?.length === 0

    const correctQuizzLength = questionLength - 1

    return (
        <ContainerStackScreen style={styles.container}>
            {!isKeyboardVisible && (
                <EvaluationQuizzHeader
                    fetchingResponse={fetchingResponse}
                    correctQuizzLength={correctQuizzLength}
                    questionLength={questionLength}
                    selectedQuizz={selectedQuizz}
                    isResult={isResult}
                />
            )}

            <View style={styles.content}>
                <CustomScrollview paddingTop={20}>
                    <RestultStatistic
                        fetchingResponse={fetchingResponse}
                        correctQuizzLength={correctQuizzLength}
                        questionLength={questionLength}
                        isResult={isResult}
                    />

                    <QuestionItems
                        isResult={isResult}
                        fetchingResponse={fetchingResponse}
                        userResponses={userResponses}
                        setPayload={setPayload}
                        setQuestionLength={setQuestionLength}
                    />

                    {isResult && (
                        <BreeSerifText
                            fontStyle="italic"
                            style={{ marginBottom: 15 }}
                            fontSize={15}
                            color={baseColors.black}
                        >
                            Explication brève à la question ci-dessus, que la réponse soit juste ou fausse.
                        </BreeSerifText>
                    )}
                </CustomScrollview>

                {!isKeyboardVisible && (
                    <View
                        style={{
                            // position: "absolute",
                            // top: isResult ? "75%" : "78%",
                            width: "100%",
                            justifyContent: "center",
                            alignSelf: "center"
                        }}
                    >
                        <Button
                            disabled={sending || disableBtn}
                            loading={sending}
                            onPress={handleClickBtn}
                            text={btnLabel}
                            width="60%"
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                            marginTop={10}
                            // marginBottom={10}
                        />
                    </View>
                )}
            </View>

            <EvaluationResultModal
                open={open}
                userId={userId}
                quizzId={quizzId}
                toggleModal={toggleModal}
                handleCheckResult={handleCheckResult}
            />
        </ContainerStackScreen>
    )
}
